// extracted by mini-css-extract-plugin
export default {"fancy-border":"styles-module__fancy-border__src-labstep-web-core-Button-_q61ag"};